import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

//use for cards
export class wmCheck extends wmBase {
    public name = "wm_check";
    public options: widgetOption<boolean>[];
    public isHidden = false;

    constructor(options: widgetOption<boolean>[]) {
        super();
        this.options = options;
    }

    public build(): string {
        const uniqValues = Array.from(new Set(this.options.map((opt) => Boolean(opt.value))));
        const singleTrue = uniqValues.length === 1 && uniqValues[0];
        this.isHidden = singleTrue;
        const selectedClass = singleTrue ? "wm_check_selected" : "";

        return `
          <div class="wm_check ${selectedClass}">
            <svg width="30" height="20" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.14282 5.71429L5.71447 9.28594L12.8571 2.14258" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        `;
    }

    public init(): void {
        const item = document.getElementsByClassName("wm_check")[0] as HTMLElement | undefined;
        if (!item) return;

        item.removeEventListener("mousedown", this.itemClick);
        item.addEventListener("mousedown", this.itemClick);
    }

    private itemClick = (_e: MouseEvent): void => {
        const otherSubm = document.getElementsByClassName("widgetSubMenu")[0] as
            | HTMLElement
            | undefined;
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        this.isHidden = !this.isHidden;
        this.applyValue(this.options, this.isHidden);

        const menuItem = document.getElementsByClassName("wm_check")[0] as HTMLElement | undefined;
        if (!menuItem) return;

        if (this.isHidden) {
            menuItem.classList.add("wm_check_selected");
        } else {
            menuItem.classList.remove("wm_check_selected");
        }
    };
}
